import React from 'react';
import { AmbassadorContentStop } from '../../../enums';
import {
  CarouselContentCardMolecule,
  SlickCarouselMolecule,
} from '../../molecules';
import { slickAmbassadorForYouSettings } from '../../../enums/ambassadors/slick-ambassador-for-you-settings';
import { useAmbassadorForYouStyles } from '../../../styles/organisms/ambassador-for-you.styles';

export const AmbassadorForYouOrganism = () => {
  const classes = useAmbassadorForYouStyles();

  function CustomNextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          backgroundColor: 'transparent',
          width: '29px',
          height: '29px',
          backgroundImage: 'url("/images/ambassadors/arrows/slider_next.svg")',
        }}
        onClick={onClick}
      />
    );
  }

  function CustomPrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          backgroundColor: 'transparent',
          backgroundImage: 'url("/images/ambassadors/arrows/slider_prev.svg")',
          width: '29px',
          height: '29px',
        }}
        onClick={onClick}
      />
    );
  }

  const arrowStyling = {
    ...slickAmbassadorForYouSettings,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
  };

  return (
    <section className="block w-full  mt-14 lg:mt-28 flex flex-col lg:flex-row justify-end">
      <div className="block w-10/12 lg:w-1/4 mx-auto lg:mx-0 max-w-full lg:max-w-xs ">
        <h2 className="text-large leading-10 w-full  lg:w-48">
          What’s in it&nbsp;
          <span className="underline inline-block">
            {AmbassadorContentStop.STOP_TITLE}
          </span>
        </h2>
        <p className="mt-5 w-9/10 max-w-xs text-lg leading-6">
          {AmbassadorContentStop.STOP_CONTENT}
        </p>
      </div>
      <div className={`${classes.AmbassadorForYouCarousel} w-full lg:w-13/20`}>
        <SlickCarouselMolecule settings={arrowStyling}>
          {AmbassadorContentStop.BENEFITS.map((benefit, index) => (
            <CarouselContentCardMolecule
              image={benefit.image}
              content={benefit.content}
              title={benefit.title}
              key={index}
            />
          ))}
        </SlickCarouselMolecule>
      </div>
    </section>
  );
};
